import { useCallback, useEffect, useState } from 'react';
import { Record } from 'immutable';
import { useDispatch, useSelector } from 'react-redux';

import { updateSession } from '../actions/sessions';
import { loadOscilarScript } from '../lib/utils/load_oscilar_script';

export default function useOscilar() {
  const dispatch = useDispatch();
  const session = useSelector((state) => state.sessions.get('session'));
  const [dandb, setDandb] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [ids, setIds] = useState({});

  const isEnabled = ['true', '1', 'yes', 'on'].includes(
    (process.env.REACT_APP_OSCILAR_ENABLED || '').toLowerCase()
  );

  // Osiclar API wrapper
  const getIds = useCallback(() => {
    if (!dandb) return;

    dandb['getIDs'] = dandb['getIDs'] || [];
    dandb['getIDs'].push((ojsIDs) => {
      setIds(ojsIDs);
    });
  }, [dandb]);

  // Osiclar API wrapper
  const commit = useCallback(
    (userID, sessionID) => {
      if (!dandb) return;

      dandb['commit'] = dandb['commit'] || [];
      dandb['commit'].push({
        userID,
        sessionID,
      });
    },
    [dandb]
  );

  useEffect(() => {
    if (!isEnabled) return;
    if (dandb) return;

    let isMounted = true;

    loadOscilarScript(process.env.REACT_APP_OSCILAR_SCRIPT_URL)
      .then((DAndB) => {
        if (isMounted) {
          setDandb(DAndB);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error(err);

        if (isMounted) {
          setError(err);
          setLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (!Object.keys(ids).length) return;
    if (!Record.isRecord(session)) return;
    if (!session.oscilar_fraud_ids.isEmpty()) return;

    dispatch(updateSession(session.set('oscilar_fraud_ids', ids))).catch(
      (err) => console.error(err)
    );
  }, [ids]);

  // Trigger for getting their IDs, runs when:
  // 1. the script is loaded
  // 2. our session object is available
  // 3. and we haven't already stored the IDs
  useEffect(() => {
    if (!isEnabled) return;
    if (!dandb) return;
    if (!Record.isRecord(session)) return;
    // ensure the session is fully baked before we try and update it
    if (!session.workflow || !session.action) return;
    if (!session.oscilar_fraud_ids.isEmpty()) return;

    getIds();
  }, [dandb, getIds, session]);

  return { dandb, loading, isReady: !!dandb, error, getIds, ids, commit };
}
